import React from "react";
import { Avatar, Box, Rating, Typography } from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import GlassCard from "./GlassCard";

export interface TestimonialData {
  quote: string;
  name: string;
  business?: string;
  location?: string;
  rating?: number;
}

const TestimonialCard: React.FC<{ testimonial: TestimonialData }> = ({
  testimonial,
}) => (
  <GlassCard tone="light" sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
    <FormatQuoteIcon sx={{ color: "secondary.light", fontSize: 36 }} />
    {typeof testimonial.rating === "number" && (
      <Rating value={testimonial.rating} precision={0.5} readOnly size="small" sx={{ mb: 1 }} />
    )}
    <Typography variant="body1" sx={{ flexGrow: 1, mb: 2.5, fontStyle: "italic" }}>
      "{testimonial.quote}"
    </Typography>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <Avatar sx={{ bgcolor: "primary.main", fontWeight: 700 }}>
        {testimonial.name.charAt(0)}
      </Avatar>
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {testimonial.name}
        </Typography>
        {(testimonial.business || testimonial.location) && (
          <Typography variant="caption" color="text.secondary">
            {[testimonial.business, testimonial.location].filter(Boolean).join(" · ")}
          </Typography>
        )}
      </Box>
    </Box>
  </GlassCard>
);

export default TestimonialCard;
